import { useState } from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";

import Verified from "../../../images/Verified-Partner.png";
import notVerified from "../../../images/notVerified.jpeg";
import {
  getPartnerGstAction,
  getPartnerGstDocuments,
} from "./../../../redux/viewPartnerDocuments/action";
import { connect } from "react-redux";
import { saveBranchGSTVerificationDetails } from "../../../redux/BranchGSTVerification/branchGSTVerification";
import UiButton from "../../Common/UiButton/UiButton";
import useSession from "../../CustomLogout/useSession";
import { Spin, message, notification } from "antd";

const BranchDetailsTab = ({
  branchDtoList,
  getPartnerGstDocuments,
  saveBranchGSTVerificationDetails,
  accessToken,
  state,
  setShow,
  getAll,
  showDrawer,
}) => {
  const [branchId, setBranchId] = useState(1);

  const [loading, setLoading] = useState(false);

  function getGstData(firmId, BranchId) {
    getPartnerGstDocuments({ firmId, BranchId, accessToken })
      .then((res) => {
        setLoading(false);
        showDrawer();
        setShow("BranchGST");
      })
      .catch((res) => {
        setLoading(false);
      });
  }

  const handleSessionExpired = useSession();
  const handleBranchTrigger = (gstNo, BranchId) => {
    setLoading(true);
    const values = {
      partnerBranchId: BranchId,
      partnerBranchGSTNo: gstNo.trim(),
      partnerBranchGSTConsentFlag: true,
      partnerBranchGSTAvailableFlag: true,
    };

    saveBranchGSTVerificationDetails({
      values,
      access_token: accessToken,
    }).then((res) => {
      setLoading(false);
      if (res && res.status === 200) {
        message.success("GST Verification details saved successfully");
        getAll();
      }
      if (res?.data?.error || res.message) {
        const errorCode = res?.data?.error?.errorCode || res.errorCode;
        const errorMessage = res?.data?.error?.message || res.message;
        setLoading(false);

        if (errorCode === "403" && res?.data?.error?.logoutStatus) {
          handleSessionExpired();
        } else {
          setLoading(false);
          notification.error({
            description: errorMessage,
            duration: 5,
            placement: "top",
          });
        }
      } else {
        setLoading(false);
      }
    });
  };

  console.log("line82", loading);
  return (
    <div className="inner-Tab-sec-edit-pat">
      <Tab.Container id="left-tabs-example" defaultActiveKey={branchId}>
        <Row>
          <Col sm={2} className="left-side-tabs branchScroll">
            <Nav variant="pills" className="flex-column">
              {branchDtoList?.length > 0
                ? branchDtoList?.map((branch, index) => {
                    return (
                      <Nav.Item onClick={() => setBranchId(index + 1)}>
                        <Nav.Link eventKey={index + 1}>
                          {" "}
                          <div className="tab-selet-test">
                            <h4>
                              {branch?.partnerBranchLocationAddress?.cityName}{" "}
                              {/* Branch */}
                              <br></br>(
                              {branch?.partnerBranchLocationAddress?.pincode})
                            </h4>
                          </div>
                        </Nav.Link>
                      </Nav.Item>
                    );
                  })
                : ""}
            </Nav>
          </Col>
          <Col sm={10}>
            <Tab.Content>
              {branchDtoList?.length > 0
                ? branchDtoList?.map((branch, index) => {
                    console.log("line 64", branch);
                    const branchAdress = branch?.partnerBranchLocationAddress;

                    const branchFullAddress = `${
                      branchAdress?.addressLine1 ?? ""
                    } ${branchAdress?.addressLine2 ?? ""} ${
                      branchAdress?.landmark ?? ""
                    } ${branchAdress?.cityName ?? ""} ${
                      branchAdress?.stateName ?? ""
                    } ${branchAdress?.countryName ?? ""} ${
                      branchAdress?.pincode ?? ""
                    }`;

                    const mobile = [223332233, 44433333];

                    const mobileNos =
                      branch.mobileNos?.length > 0
                        ? branch?.mobileNos
                            ?.map((mobileNo) => mobileNo)
                            .join(", ")
                        : "";
                    return (
                      <Tab.Pane eventKey={index + 1}>
                        <Row>
                          <Col
                            lg={12}
                            xs={12}
                            md={12}
                            sm={12}
                            className="ineer-ed-text tabs-sec"
                          >
                            <Col md={6} className="">
                              <div className="text-content-ed">
                                <h5>Branch Address Details</h5>
                                <h2>{branchFullAddress}</h2>
                                <br />
                                <h2>
                                  {branch?.officeOwnerships?.name} |{" "}
                                  {branch?.officeInLocalitys?.name} |{" "}
                                  {branchAdress?.yearsAtCurrentAddress ?? ""}{" "}
                                  years
                                </h2>
                              </div>
                            </Col>
                            <Col md={6} className="">
                              <div className="text-content-ed">
                                <h5>Contact Details </h5>
                                <h2>
                                  {branch?.contactPerson ?? ""}
                                  {mobileNos}
                                  <br></br>
                                  {branch?.emailAddress}
                                </h2>
                              </div>
                            </Col>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            lg={12}
                            xs={12}
                            md={12}
                            sm={12}
                            className="ineer-ed-text tabs-sec"
                          >
                            <Col md={6} className="">
                              <div className="text-content-ed">
                                <h5>Gst Details </h5>

                                <div className="pan-ver">
                                  <div
                                    className="view-pan-details"
                                    onClick={() => {
                                      getGstData(
                                        branch.partnerFirmId,
                                        branch.partnerBranchId
                                      );
                                    }}
                                  >
                                    <h2> {branch?.partnerBranchGSTNo}</h2>
                                  </div>
                                  {branch?.partnerBranchGSTVerifiedFlag ==
                                    true && (
                                    <div>
                                      <img src={Verified} alt="" />
                                      {state?.userData?.loggedInRoleType !==
                                      "PARTNER" ? (
                                        <div
                                          onClick={() => {
                                            getGstData(
                                              branch.partnerFirmId,
                                              branch.partnerBranchId
                                            );
                                          }}
                                          style={{ cursor: "pointer" }}
                                        >
                                          <b
                                            style={{
                                              color: "blue",
                                              marginLeft: "2vw",
                                            }}
                                          >
                                            View Response
                                          </b>
                                          {branch?.isBranchStateMatchedWithGstState ? (
                                            <p
                                              className="pan-match-text"
                                              style={{
                                                color: "green",
                                                marginLeft: "2vw",
                                              }}
                                            >
                                              GSt Matched with the state
                                            </p>
                                          ) : (
                                            <p
                                              className="pan-match-text-red"
                                              style={{ color: "red" }}
                                            >
                                              GST doesn't match with the state
                                            </p>
                                          )}
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  )}
                                  {branch?.partnerBranchGSTVerifiedFlag ==
                                    null && <b>No GST data</b>}
                                </div>
                                {branch?.partnerBranchGSTVerifiedFlag ==
                                  false && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <img
                                      className="notverified"
                                      src={notVerified}
                                    />
                                    {state?.userData?.loggedInRoleType ===
                                    "CET" ? (
                                      <div>
                                        <UiButton
                                          style={{ width: "150px" }}
                                          onClick={() =>
                                            handleBranchTrigger(
                                              branch?.partnerBranchGSTNo,
                                              branch.partnerBranchId
                                            )
                                          }
                                          type="submit"
                                          title="retrigger"
                                        />
                                        {loading && <Spin />}
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                )}

                                {/* {branch?.partnerBranchGSTVerifiedFlag ==
                                  false &&
                                  state?.userData?.loggedInRoleType ===
                                    "RM" && <b>No GST data</b>} */}
                              </div>
                            </Col>
                          </Col>
                        </Row>
                      </Tab.Pane>
                    );
                  })
                : ""}

              {/* <Tab.Pane eventKey="first">
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec"
                  >
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        <h5>Address Details</h5>
                        <h2>
                          1 Anand Nagar, Opp Ramdevpir Mandir,<br></br>
                          Chandlodiar, Gandhi Nagar<br></br>
                          Ahmedabad - 382481, Gujarat<br></br>
                          <br></br>
                          Rented | Commerical | 5.2 yeas
                        </h2>
                      </div>
                    </Col>
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        <h5>Contact Details </h5>
                        <h2>
                          Samsher Singh 8393740441, 8030484088<br></br>
                          info_mumbai@excelpartner.com
                        </h2>
                      </div>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec"
                  >
                    <Col md={6} className=""></Col>
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        <h5>Gst Details </h5>

                        <div className="pan-ver">
                          <h2> 27AAJDHEURB37</h2>
                          <img src={Verified} alt="" />
                        </div>
                      </div>
                    </Col>
                  </Col>
                </Row>
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                {" "}
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec"
                  >
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        <h5>Address Details</h5>
                        <h2>
                          1 Anand Nagar, Opp Ramdevpir Mandir,<br></br>
                          Chandlodiar, Gandhi Nagar<br></br>
                          Ahmedabad - 382481, Gujarat<br></br>
                          <br></br>
                          Rented | Commerical | 5.2 yeas
                        </h2>
                      </div>
                    </Col>
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        <h5>Contact Details </h5>
                        <h2>
                          Samsher Singh 8393740441, 8030484088<br></br>
                          info_mumbai@excelpartner.com
                        </h2>
                      </div>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec"
                  >
                    <Col md={6} className=""></Col>
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        <h5>Gst Details </h5>

                        <div className="pan-ver">
                          <h2> 27AAJDHEURB37</h2>
                          <img src={Verified} alt="" />
                        </div>
                      </div>
                    </Col>
                  </Col>
                </Row>
              </Tab.Pane>
              <Tab.Pane eventKey="third">
                {" "}
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec"
                  >
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        <h5>Address Details</h5>
                        <h2>
                          1 Anand Nagar, Opp Ramdevpir Mandir,<br></br>
                          Chandlodiar, Gandhi Nagar<br></br>
                          Ahmedabad - 382481, Gujarat<br></br>
                          <br></br>
                          Rented | Commerical | 5.2 yeas
                        </h2>
                      </div>
                    </Col>
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        <h5>Contact Details </h5>
                        <h2>
                          Samsher Singh 8393740441, 8030484088<br></br>
                          info_mumbai@excelpartner.com
                        </h2>
                      </div>
                    </Col>
                  </Col>
                </Row>
                <Row>
                  <Col
                    lg={12}
                    xs={12}
                    md={12}
                    sm={12}
                    className="ineer-ed-text tabs-sec"
                  >
                    <Col md={6} className=""></Col>
                    <Col md={6} className="">
                      <div className="text-content-ed">
                        <h5>Gst Details </h5>

                        <div className="pan-ver">
                          <h2> 27AAJDHEURB37</h2>
                          <img src={Verified} alt="" />
                        </div>
                      </div>
                    </Col>
                  </Col>
                </Row>
              </Tab.Pane> */}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    accessToken: state?.auth?.idToken,
    DocData: state?.PanDocs,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPartnerGstDocuments: (data) => dispatch(getPartnerGstDocuments(data)),
    saveBranchGSTVerificationDetails: (data) =>
      dispatch(saveBranchGSTVerificationDetails(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BranchDetailsTab);
